<template lang='pug'>
  div(:class='{"dark": $vuetify.theme.dark, "light": !$vuetify.theme.dark}')
    v-row.pl-4.pr-5.pt-1.pb-1.list-item.clickable(
      no-gutters
      @click='to(`/results/${testSuite.runGuid}?index=${index}`)'
      @click.right.stop.prevent='to(`/test/${test.guid}`)')
      v-col.text-subtitle-1(
        cols='9'
        sm='10')
        router-link(:to='`/results/${testSuite.runGuid}?index=${index}`') {{test.name}}
      v-col.text-right
        v-tooltip(right)
          template(v-slot:activator='{on}')
            div(v-on='on')
              bionic-metrics-test-row-status(:status='status' :is-running='isRunning' :disabled='isDisabled')
          div(v-if='testStatus')
            strong {{test.name}}
            div(v-if='statusUpdatedAt')
              | Updated {{statusUpdatedAt | timeago}}
            div {{textStatus}}
    v-divider
</template>

<script>
import UtilMixin from '@/mixins/util.mixin';
import BionicMetricsRunningIndicatorCircular from '@/components/RunningIndicatorCircular';
import BionicMetricsTestRowStatus from '@/components/TestRowStatus';

export default {
  name: 'BionicMetricsTestRow',
  components: {BionicMetricsTestRowStatus, BionicMetricsRunningIndicatorCircular},
  mixins: [UtilMixin],
  props: {
    testSuite: {
      type: Object
    },
    test: {
      type: Object
    },
    testStatus: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    isRunning() {
      return this.testStatus && this.testStatus.isRunning;
    },
    status() {
      if (!this.testStatus) return 'NO_DATA';
      return this.testStatus.status;
    },
    isDisabled() {
      return this.test && this.test.disabled;
    },
    textStatus() {
      if (this.test && this.test.disabled) return 'Disabled';
      if (this.isRunning) return 'Running';
      if (this.status === 'PASSING') return 'Passing';
      if (this.status === 'FAILING') return 'Failing';
      if (this.status === 'FAULT') return 'Fault';
      if (this.status === 'DISABLED') return 'Disabled';
      return 'No Data Yet';
    },
    statusUpdatedAt() {
      if (!this.testStatus) return null;
      return this.testStatus.statusUpdatedAt;
    }
  }
};
</script>

<style scoped>
.light .list-item:hover {
  background-color: #EEEEEE;
}

.dark .list-item:hover {
  background-color: #444444;
}
</style>
